import { PropsWithChildren } from 'react';

import { Portal } from '@mui/material';

export const ToolboxHeader = ({ children }: PropsWithChildren) => {
  return (
    <Portal container={() => document.getElementById('toolbox-header')}>
      {children}
    </Portal>
  );
};
